import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useUserStore } from '../store/useUserStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMatchStore } from '../store/useMatchStore';
import location_dark from '../assets/images/location_dark.png';
import heart_dark from '../assets/images/heart_dark.png';
import ruler_dark from '../assets/images/ruler_dark.png';
import wine_icon from '../assets/images/wine_icon.png';
import pet_icon from '../assets/images/pet_icon.png';
import education_icon from '../assets/images/education_icon.png';
import kids_red from '../assets/images/kids_red.png';
import globe_icon from '../assets/images/globe_icon.png';
import tshirt_icon from '../assets/images/tshirt_icon.png';
import weet_icon from '../assets/images/weet_icon.png';
import workout_icon from '../assets/images/workout_icon.png';
import love_diamond from '../assets/images/love_diamond.png';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import useAuthStore from '../store/useAuthStore';
import { useMessageStore } from '../store/useMessageStore';
import { useSendLikeStore } from '../store/useSendLikeStore';
import { Button, Modal } from "react-bootstrap";
import { usePitchesStore } from '../store/usePitchesStore';
import ProfileCarousel from '../components/ProfileCarousel';
const MySwal = withReactContent(Swal);


type Photo = {
  picture: string;
  orignal_picture: string;

}; 
const LikeProfileDetails = () => {
    const { userId } = useParams<{ userId: string }>();
    const { requestId } = useParams<{ requestId: string }>();
  const { user, loading,  getUserDetails,genres, fetchGenres  } = useUserStore();
  const { getMessages, userMessages } = useMessageStore();
  const [showModal, setShowModal] = useState(false);
  const { loadinglike, sendLike } = useSendLikeStore();
  const {deleteRequest } = usePitchesStore();
  const navigate = useNavigate();
  const { blockUser,
    reportUser, } = useMatchStore();
    const [messages, setMessages] = useState<any[]>([]);
    const authStore = useAuthStore.getState();
     const [backgroundPhotos, setBackgroundPhotos] = useState<Photo[]>([]);
  
    useEffect(() => {
   
    
        setMessages(userMessages);
        
      }, [userMessages]);
  useEffect(() => {
    console.log('userId:', userId);
    
    if (userId) {
     
      getUserDetails(parseInt(userId));
      fetchGenres();
      getMessages(authStore.user?.id,parseInt(userId),1);
    }
  }, [userId,getUserDetails]); 



  const handleLike = async (userId:any, requestId:any) => {
    await sendLike(parseInt(userId), 50, "", requestId);
    setShowModal(true); // Show modal after liking
  };
  const confirmDeleteRequest = (requestId:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Delete Request?</h3>
          <p>Do you really want to delete this request?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={() => { 
              deleteRequest(parseInt(requestId)); 
              MySwal.close();
            }}>
              Yes, Delete
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };


  const getAnswerBySubtitle = (subTitle: any) => {
    const answer = user.user_answers.find((ans:any) => {
        console.log("Subtitle in answer:", ans.question); // Logging here
        return ans.question != null && ans.question.sub_title === subTitle;
      });
     
        const skipFormatting = ['Politics', 'Kids_People'];

     
      if (!answer) return skipFormatting.includes(subTitle)
            ? `Not specified`
            : `${subTitle
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (c: string) => c.toUpperCase())}: Not specified`;
  
      let answerIds = answer.answer_id;

      // Handle stringified array like ["Affectionate", "Agreeable "]
      try {
        const parsed = JSON.parse(answerIds);

        if (Array.isArray(parsed)) {
          answerIds = parsed;
        }
      } catch (e:any) {
        console.log(e);
        
        // If parsing fails, it means it's not a JSON string, ignore the error
      }
    
      // If the answer is still a string, split by commas or trim spaces
      if (typeof answerIds === 'string') {
        answerIds = answerIds.includes(',')
          ? answerIds.split(',').map((item) => item.trim())
          : [answerIds.trim()];
      }
     
       // Ensure it's an array
        answerIds = Array.isArray(answerIds) ? answerIds : [answerIds];

        console.log("Processed Answer IDs:", answerIds);
        console.log("Question Options:", answer.question.questions_options);

         // Check if question_options exist and match by option or ID
            const options = answer.question.questions_options
            ? answerIds
                .map((id: any) => {
                    const option = isNaN(id)
                    ? answer.question.questions_options.find((opt: any) => opt.option.trim() === id.trim()) // Match by option if not a number
                    : answer.question.questions_options.find((opt: any) => opt.id == id); // Match by ID if a number

                    console.log(`Matching Option for ID/Option "${id}":`, option);
                    return option?.option;
                })
                .filter(Boolean)
            : answerIds;

            console.log("Final Options:", options);

            return options.length > 0 ? options.join(', ') : 'Not specified';
    };

    const confirmBlockUser = (userId:any, blockUser:any) => {
      MySwal.fire({
        html: (
          <div className="text-center">
            <h3>Block User?</h3>
            <p>Do you really want to block this user?</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={() => { 
                blockUser(userId,requestId); 
                navigate('/liked');
                MySwal.close();
              }}>
                Yes, Block
              </button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'bg-light p-4 rounded',
          closeButton: 'btn-close position-absolute top-0 end-0 m-3',
        },
      });
    };
  
  
    
    const confirmReportUser = (userId:any, reportUser:any) => {
      MySwal.fire({
        html: (
          <div className="text-center">
            <h3>Report User</h3>
            <p>Please enter the reason for reporting this user:</p>
            <textarea
              id="reportReason"
              className="form-control mb-3"
              placeholder="Enter your reason..."
              style={{ height: '100px', resize: 'none' }}
            ></textarea>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  const reasonInput = document.getElementById('reportReason') as HTMLTextAreaElement;
                  if (!reasonInput || !reasonInput.value.trim()) {
                    MySwal.showValidationMessage('Reason is required.');
                    return;
                  }
                  reportUser(userId, reasonInput.value.trim());
                  MySwal.close();
                  MySwal.fire('Reported!', 'The user has been reported successfully.', 'success');
                }}
              >
                Submit Report
              </button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'bg-light p-4 rounded',
          closeButton: 'btn-close position-absolute top-0 end-0 m-3',
        },
      });
    };    


    const convertHeightToCm = (height:any) => {
        console.log(height);
        height = height.replace(/’/g, "'").replace(/”/g, '"');
        const match = height.match(/(\d+)' (\d+)"/); // Extract feet and inches
        if (!match) return "Invalid height"; // Handle incorrect formats
      
        const feet = parseInt(match[1], 10);
        const inches = parseInt(match[2], 10);
        const cm = (feet * 30.48) + (inches * 2.54);
      
        return `${cm.toFixed(0)} cm`; // Return with 1 decimal place
      };


        // Get selected genres based on genre IDs in the user data
  const getSelectedGenres = () => {
    if (!user || !user.genres || !genres || !genres.length) return [];
    const genreIds = user.genres.split(',').map((id:any) => parseInt(id.trim()));
    return genres.filter((genre) => genreIds.includes(genre.id));
  };





const selectedGenres = getSelectedGenres();

    const userGenres = authStore.user?.genres?.split(",").map(Number); // Convert to an array of numbers
    let commonGenres:any =[];
    if(userGenres){
    commonGenres = selectedGenres.filter(genre => 
    userGenres.includes(genre.id) // Check if genre.id is in userGenres
    );
    }

useEffect(() => {
  if (user && Array.isArray(user.user_photos)) {
   // const filtered = user.user_photos.filter((photo: any) => photo.main_photo == 0);
    setBackgroundPhotos(user.user_photos);
    
    
  }
}, [user]);

  if (loading) return <div className="text-center mt-4">Loading...</div>;
  return (
    <section className="pt-4 pb-60 bg-light dating_profile_page">
    <div className="container">
        <div className="dp_profile_top_bredcrumb mb-4">
            <Link to="/liked" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </Link>
            <div className="dp_profile_drpdwn_wrpr">
                <button className="btn btn-sm dropdown-toggle dp_profile_info_drpdwn" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    Flag as inappropriate <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul className="dropdown-menu">
                <li><button className="dropdown-item" onClick={() => confirmBlockUser(user.id, blockUser)}>Block User</button></li>
                <li><button className="dropdown-item" onClick={() => confirmReportUser(user.id, reportUser)}>Report</button></li>
                </ul>
            </div>
        </div>
        {user && (
        
        <div className="row">
            <div className="col-lg-8 mb-3">
                <div className="card dating_profile_details_card p-4">

                       <ProfileCarousel
                                        backgroundPhotos={backgroundPhotos}
                                        user={user}
                                       
                                      />

                       
                    
                    
                    <div className="dp_details_profile_info pt-4">
                        <div className="row align-items-center">
                            <div className="col-xl-8">
                                <h2>{user.first_name}, {user.age}
                                {/* {user.confirm ==1 ?   
                                <span className="badge badge-photo-verified ms-2">
                                    <img src={badge_check} alt="Verified" style={{ width: 16, height: 16, marginRight: 4 }} />
                                    Photo-verified
                                </span>
                                :''} */}

                                </h2>
                                <ul>
                                    <li><img src={location_dark} />{user.city}, {user.distance.toFixed(0)} miles away</li>
                                    <li><img src={heart_dark} />{getAnswerBySubtitle('Relationship_status')}</li>
                                    <li><img src={ruler_dark} />{user.height} ({convertHeightToCm(user.height)})</li>
                                </ul>
                            </div>
                           
                        </div>
                        <div className="border-top pt-3 mt-3">
                          <p>{user.know_about_you}</p>
                            {/* <p className="font18">“{user.profile_vibe}”</p> */}
                        </div>
                        <div className="border-top pt-3 mt-3">
                            <h5 className="font18 mb-3">Common Interests</h5>
                            <div className="danger_badge_group">
                            {commonGenres.length > 0 ? (
                                commonGenres.map((genre:any, index:any) => (
                                  <span key={index}>{genre.name}</span>
                                ))
                              ) : (
                                <span>No common interests</span>
                              )}
                                
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="card mt-4 p-4">
                    <h5 className="font22 mb-3 pb-3 border-bottom">Bio</h5>
                    <p>{user.know_about_you}</p>
                </div> */}
                <div className="card mt-4 p-4 ">
                    <h5 className="font22 mb-4 pb-3 border-bottom">About</h5>
                    <div className="row g-4">
                  


                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-venus"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Gender')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-regular fa-heart"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Relationship_status')}, intent: {getAnswerBySubtitle('Looking_Relationship')}, interested in {getAnswerBySubtitle('Seeking')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={education_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Education')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-briefcase"></i></div>
                                <p className="mb-0 font18 ms-2 capitalize-first ">{user.occupation}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-book-open"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Religion')}</p>
                            </div>
                        </div>
                           <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={kids_red} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_kids')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={globe_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Ethnicity')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={tshirt_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Body_type')}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card mt-4 p-4 ">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Lifestyle</h5>
                    <div className="row g-4">
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-smoking"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Smokes')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={weet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('420_firendly')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={wine_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Drinks')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={workout_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Exercise')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={pet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_pets')}</p>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Personality Type</h5>
                    <div className="danger_outline_badge_group">
                        {Array.isArray(getAnswerBySubtitle('Personality'))
                        ? getAnswerBySubtitle('Personality').map((trait: string, index: number) => (
                            <span key={index}>
                            {trait}
                            </span>
                        ))
                        : getAnswerBySubtitle('Personality').split(',').map((trait: string, index: number) => (
                            <span key={index}>
                            {trait}
                            </span>
                        ))
                     }
                     
                    </div>


                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Extended Profile</h5>
                    <div className="danger_outline_badge_group">
            
                        <span>{getAnswerBySubtitle('Horoscope')}</span>
                        <span>Looking for match between {user.looking_min_age}-{user.looking_max_age}</span>
                        <span>Political affiliation is {getAnswerBySubtitle('Politics')}</span>
                        <span>Will date people that have Kid? -  {getAnswerBySubtitle('Kids_People')}</span>
                    </div>
                </div>
                <div className="card mt-4 p-4">
                    <h5 className="font22 mb-4 pb-3 border-bottom">Interests Feature</h5>
                    <div className="danger_outline_badge_group">
                    {selectedGenres.length > 0 ? (
                      selectedGenres.map((genre, index) => (
                        <span key={index} >
                          {genre.name}
                        </span>
                      ))
                    ) : (
                      <span>No interests selected</span>
                    )}
                       
                    </div>
                </div>
            </div>
            <div className="col-lg-4">
                {!messages || messages.length === 0 ? (
                    <div className="card dp_message_box_right border mt-3">
                    <div className="border-bottom pb-3 mb-3 d-flex w-100 align-items-center gap-3">
                        <span className="icon_box">
                        <i className="fa-regular fa-envelope"></i>
                        </span>
                        <h4 className="mb-0">No message yet</h4>
                    </div>

                    <div>
                        <div className="dp_actions_btngroup mt-0">
                        <div className="dp_actions_btn_item">
                            <button className="btn pass_btn" onClick={() => confirmDeleteRequest(requestId)}>
                            <i className="fa-solid fa-xmark"></i>
                            </button>
                            Pass
                        </div>

                        <div className="dp_actions_btn_item">
                            <button className="btn like_btn" onClick={() => handleLike(userId, requestId)}
                            disabled={loadinglike}>
                            <i className="fa-regular fa-heart"></i>
                            </button>
                            Like
                        </div>
                        </div>
                    </div>
                    </div>
                ) : (
                    <div className="card dp_message_box_right border">
                    <div className="border-bottom pb-3 mb-3 d-flex w-100 align-items-center gap-3">
                        <span className="icon_box">
                        <i className="fa-regular fa-envelope"></i>
                        </span>
                        <h4 className="mb-0">Message from {user.first_name}</h4>
                    </div>

                    {/* Message List */}
                    <div className="dp_message_box_lists_main">
                        {messages.map((msg, index) => (
                        <div key={index} className="dp_message_box_lists mb-2">
                            <span className="dp_message_box_profile">
                            {msg.from == userId ? `${user.first_name.charAt(0)}` : 'You'}
                            </span>
                            <div className="dp_message_box_lists_profile">
                            {msg.message}
                            </div>
                        </div>
                        ))}
                    </div>

                    <div>
                        <div className="bg-light rounded-pill py-2 px-3 mt-3 d-inline-block w-auto">
                        <i className="fa-solid fa-circle-info me-2"></i> Match with {user.first_name} to start chatting.
                        </div>
                        <div className="dp_actions_btngroup border-top pt-4">
                        <div className="dp_actions_btn_item">
                            <button className="btn pass_btn" onClick={() => confirmDeleteRequest(requestId)}>
                            <i className="fa-solid fa-xmark"></i>
                            </button>
                            Pass
                        </div>

                        <div className="dp_actions_btn_item">
                            <button className="btn like_btn" 
                            onClick={() => handleLike(userId, requestId)}
                            disabled={loadinglike}>
                            <i className="fa-regular fa-heart"></i>
                            </button>
                            Like
                        </div>
                       
                        </div>
                    </div>
                    </div>
                )}
             </div>


                </div>
        
      )}
    </div>
    {/* Match Modal */}
                        <Modal show={showModal} onHide={() => {setShowModal(false); navigate(`/matched`);}} centered>
                                  <Modal.Header closeButton />
                                  <Modal.Body className="text-center py-5 px-4">
                                    <img src={love_diamond} alt="" className="dp_user_img mb-3" />
                                    <h3>🎉 It's a Match! 🎉</h3>
                                    <p>
                                      Start exploring your connection with the Love Diamond, where you can express your interest.
                                      Make the first move and send a message!
                                    </p>
                                    <Button onClick={() => {navigate(`/matched`);}} variant="primary" className="py-2">Start Chatting</Button>
                                  </Modal.Body>
                                </Modal>
</section>

  );
};

export default LikeProfileDetails;
